"use strict";

exports.__esModule = true;
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactCollapse = require("@homeaway/react-collapse");
require("./styles.css");
var _propTypes = _interopRequireDefault(require("prop-types"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _inheritsLoose(t, o) { t.prototype = Object.create(o.prototype), t.prototype.constructor = t, _setPrototypeOf(t, o); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
var ICMenu = /*#__PURE__*/function (_Component) {
  function ICMenu(props) {
    var _this;
    _this = _Component.call(this, props) || this;
    _this.handleClickOutside = _this.handleClickOutside.bind(_this);
    return _this;
  }
  _inheritsLoose(ICMenu, _Component);
  var _proto = ICMenu.prototype;
  _proto.componentDidMount = function componentDidMount() {
    document.addEventListener("mousedown", this.handleClickOutside);
  };
  _proto.componentWillUnMount = function componentWillUnMount() {
    document.removeEventListener("mousedown", this.handleClickOutside);
  };
  _proto.handleClickOutside = function handleClickOutside(event) {
    /* istanbul ignore else */
    if (!this.icMenuNode || this.icMenuNode.contains(event.target)) {
      return;
    }
    /* istanbul ignore else */
    if (this.props && this.props.hideMenu) {
      this.props.hideMenu();
    }
  };
  _proto.shouldExpand = function shouldExpand(contents, pathName) {
    var _this2 = this;
    return contents.find(function (item) {
      return pathName === item.path || item.contents && _this2.shouldExpand(item.contents, pathName);
    });
  };
  _proto.getMenuItemLabel = function getMenuItemLabel(nav) {
    var translations = this.props.translations;
    if (nav.value) {
      return nav.value;
    }
    return translations && translations[nav.label] ? translations[nav.label] : nav.label;
  };
  _proto.getMenuItems = function getMenuItems(navLinks, pathName) {
    var _this3 = this;
    if (!navLinks) {
      return null;
    }
    return navLinks.map(function (nav, i) {
      if (nav.enabled !== false && nav.contents && nav.contents.length > 0) {
        return /*#__PURE__*/_react.default.createElement(_reactCollapse.Divider, {
          id: "ic-collapsable-menu-item-" + i,
          key: "ic-collapsable-menu-item-" + i,
          className: "hide-divider-styles ic-collapsable-menu-item ic-menu-item " + (nav.enabled === false ? "disabled" : "") + " " + (nav.label && nav.label === _this3.props.activeLink ? "active-divider" : ""),
          heading: _this3.getMenuItemLabel(nav),
          expanded: _this3.shouldExpand(nav.contents, pathName)
        }, _this3.getMenuItems(nav.contents, pathName));
      }
      return /*#__PURE__*/_react.default.createElement("div", {
        key: "menu-item-" + i,
        className: "ic-menu-item " + (nav.enabled === false ? "disabled" : "") + " " + (nav.path === pathName || nav.label && nav.label === _this3.props.activeLink ? "selected" : "")
      }, /*#__PURE__*/_react.default.createElement("a", {
        href: nav.enabled !== false ? nav.path : "#"
      }, _this3.getMenuItemLabel(nav)));
    });
  };
  _proto.render = function render() {
    var _this4 = this;
    if (this.props.mobile && !this.props.visible) {
      return null;
    }
    var pathName;
    var navLinks = this.props.navLinks;
    var apps = navLinks && navLinks instanceof Array ? navLinks.filter(function (nav) {
      return nav.application !== false;
    }) : null;
    if (typeof window !== "undefined") {
      pathName = window.location.pathname.replace(/\/$/, "");
    }
    return /*#__PURE__*/_react.default.createElement("div", {
      ref: function ref(icMenuNode) {
        _this4.icMenuNode = icMenuNode;
      },
      className: "ic-menu-options " + (this.props.mobile ? "mobile" : "no-mobile")
    }, this.getMenuItems(apps, pathName));
  };
  return ICMenu;
}(_react.Component);
/* eslint-disable no-undef */
ICMenu.propTypes = {
  /** Navigation links to display in the menu.
   * 'enabled' and 'application' are both defaulted to true.
   * Setting 'enabled' to false will render the link in disabled/non-clickable state.
   * Setting 'application' to false will not render the link.
   * 'path' - nav link href.
   * 'value' - label on nav link.
   * 'label' - lingua key, used when value is undefined.
   * 'contents' - sub contents (if any) - has the same structure as navLinks.
   */
  navLinks: _propTypes.default.arrayOf(_propTypes.default.shape({
    enabled: _propTypes.default.bool,
    application: _propTypes.default.bool,
    path: _propTypes.default.string,
    value: _propTypes.default.string,
    label: _propTypes.default.string,
    contents: _propTypes.default.array
  })),
  /** label of the menu item that should be highlighted.*/
  activeLink: _propTypes.default.string,
  /** translations for navLinks[{label}] when navLinks[{value}] is not defined. */
  translations: _propTypes.default.objectOf(_propTypes.default.string)
};
var _default = exports.default = ICMenu;
//# sourceMappingURL=index.js.map